import type { PuppyId, Breed } from './types';

export interface Puppy {
  readonly id: PuppyId;
  readonly displayName: string;
  readonly breed: Breed;
  readonly puppyNdx: number;
  readonly puppyNum: number;
  readonly numAnims: number;
}

// Order matches Puppy.swift's puppyNames array — this is what
// puppyIndex 0..9 maps to. Atlas paths in the iOS app are p<num>a<n>
// where num = puppyNdx + 1.
const ROSTER: readonly Puppy[] = [
  { id: 'doug',     displayName: 'Doug',     breed: 'labrador',       puppyNdx: 0, puppyNum: 1,  numAnims: 5 },
  { id: 'zoe',      displayName: 'Zoe',      breed: 'bichon',         puppyNdx: 1, puppyNum: 2,  numAnims: 5 },
  { id: 'princess', displayName: 'Princess', breed: 'chihuahua',      puppyNdx: 2, puppyNum: 3,  numAnims: 5 },
  { id: 'clancy',   displayName: 'Clancy',   breed: 'scottie',        puppyNdx: 3, puppyNum: 4,  numAnims: 5 },
  { id: 'wesley',   displayName: 'Wesley',   breed: 'germanShepherd', puppyNdx: 4, puppyNum: 5,  numAnims: 5 },
  { id: 'fabio',    displayName: 'Fabio',    breed: 'greyhound',      puppyNdx: 5, puppyNum: 6,  numAnims: 5 },
  { id: 'bella',    displayName: 'Bella',    breed: 'cavalier',       puppyNdx: 6, puppyNum: 7,  numAnims: 4 },
  { id: 'alex',     displayName: 'Alex',     breed: 'pug',            puppyNdx: 7, puppyNum: 8,  numAnims: 5 },
  { id: 'chief',    displayName: 'Chief',    breed: 'dalmatian',      puppyNdx: 8, puppyNum: 9,  numAnims: 5 },
  { id: 'wally',    displayName: 'Wally',    breed: 'bluetick',       puppyNdx: 9, puppyNum: 10, numAnims: 5 },
];

const BY_ID: Record<PuppyId, Puppy> = Object.fromEntries(ROSTER.map((p) => [p.id, p])) as Record<
  PuppyId,
  Puppy
>;

export function allPuppies(): readonly Puppy[] {
  return ROSTER;
}

export function puppyForId(id: PuppyId): Puppy {
  return BY_ID[id];
}

export function puppyForIndex(ndx: number): Puppy {
  const p = ROSTER[ndx];
  if (!p) throw new Error(`puppyForIndex out of range: ${ndx}`);
  return p;
}
